'use client';


/** Imports */
import RouteSegmentError from '@/components/ErrorBoundary/RouteSegmentError';


/** Component */
export default function Error(props: Readonly<{
    error: Error & {digest?: string};
    reset: () => void;
}>) {
    return <RouteSegmentError {...props}/>;
}
